import { useEffect, useState } from 'react';

import { useAppSelector, useResizeLayout } from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';
import { useGetBalanceMutation } from '@Features/EmployeeSelfService/requests/LeaveRequest/store/api/leaveRequestApiSlice';
import { Balance } from '@Types/api/form/leaveRequest/Balance';

import { LatestRequests } from './components/LatestRequests';
import { Summary } from './components/Summary';

const LeaveBalance: React.FC = () => {
  const { isMobile } = useResizeLayout();

  const currentUser = useAppSelector(currentUserSelector);

  const [balance, setBalance] = useState<Balance | null>(null);

  const [getBalance] = useGetBalanceMutation();

  useEffect(() => {
    if (!currentUser.empNumber) {
      return;
    }

    getBalance({ empNumber: currentUser.empNumber })
      .unwrap()
      .then((balanceResp) => {
        setBalance(balanceResp);
      })
      .catch(() => {});
  }, [currentUser]);

  return (
    <>
      <Summary isMobile={isMobile} balance={balance} />
      <LatestRequests />
    </>
  );
};

export default LeaveBalance;
